module.exports = __webpack_public_path__ + "static/joomla-map-8f11b14e3fc51b22bad5f80e092ba255.png";